interface Props {
  children: React.ReactNode;
  accent?: boolean;
  className?: string;
}

export default function Eyebrow({ children, accent = false, className = '' }: Props) {
  return (
    <span
      className={`font-mono text-[11px] uppercase font-medium tracking-[0.12em] ${
        accent ? 'text-accent' : 'text-faint'
      } ${className}`}
    >
      {children}
    </span>
  );
}
